module.exports = __webpack_public_path__ + "img/P1070895.f66224e8.jpg";